'use client'

import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { InstantSearchNext } from 'react-instantsearch-nextjs'

import TableArchiveItems from '@/components/table-archive/TableArchiveItems'

import FilterToolbar from '@/components/filters/FilterToolbar'
import FilterModal from '@/components/filters/FilterModal'
import FilterModalFooter from '@/components/filters/FilterModalFooter'
import FilterModalComponents from '@/components/filters/FilterModalComponents'
import FilterStats from '@/components/filters/FilterStats'
import FilterSearchBox from '@/components/filters/FilterSearchBox'
import FilterPagination from '@/components/filters/FilterPagination'

import type { FilterPropsType } from '@/layouts/types'

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
)

type TableArchiveWrapperProps = {
  algoliaIndex: string
  columns: string[]
  filters: FilterPropsType
}

export default function TableArchiveWrapper({
  algoliaIndex,
  columns,
  filters,
}: TableArchiveWrapperProps): JSX.Element {
  return (
    <InstantSearchNext
      searchClient={searchClient}
      indexName={algoliaIndex}
      routing
      future={{
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      }}>
      <div className="hidden" aria-hidden="true">
        <FilterModalComponents filters={filters} />
      </div>

      <div className="container py-l ms:mt-m">
        <FilterToolbar
          leftChildren={
            <div className="flex items-center gap-x-s">
              <FilterModal footerComponent={<FilterModalFooter />}>
                <FilterModalComponents filters={filters} />
              </FilterModal>
            </div>
          }
          rightChildren={
            <div className="flex w-full justify-end gap-x-l">
              <FilterSearchBox />
            </div>
          }
        />
      </div>

      <div
        className="container mb-xl grid grid-cols-1 gap-y-xl"
        style={{ scrollMarginTop: '80px' }}>
        <TableArchiveItems columns={columns} />
      </div>

      <div className="my-m border-t pt-m text-center">
        <div className="container flex items-center justify-between ms:flex-col ms:gap-y-s">
          <FilterStats />
          <FilterPagination />
        </div>
      </div>
    </InstantSearchNext>
  )
}
